import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import NewPricePlanSelfCareBlockData from '../../../Models/Content/NewPricePlanSelfCareBlockData';
import NewPricePlanSelfCareBlock from './NewPricePlanSelfCareBlock';

export default class PopupBenefitBlock extends EpiComponent<NewPricePlanSelfCareBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <NewPricePlanSelfCareBlock context={this.getContext()} iContent={this.props.data} />;
  }
}
